/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screens_Not_DifficultInputs */

const en_onboarding_screens_not_difficult = /** @type {(inputs: Onboarding_Screens_Not_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A - it's not physically difficult`)
};

const es_onboarding_screens_not_difficult = /** @type {(inputs: Onboarding_Screens_Not_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A - no es físicamente difícil`)
};

/**
* | output |
* | --- |
* | "N/A - it's not physically difficult" |
*
* @param {Onboarding_Screens_Not_DifficultInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_screens_not_difficult = /** @type {((inputs?: Onboarding_Screens_Not_DifficultInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screens_Not_DifficultInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_screens_not_difficult(inputs)
	return en_onboarding_screens_not_difficult(inputs)
});